<template>
    <div>
        <b-alert
            variant="success"
            :show="showAlert_success"
            @dismissed="showAlert_success = false"
            >{{ alert_success_message }}</b-alert
        >

        <b-alert
            variant="danger"
            :show="showAlert_error"
            @dismissed="showAlert_error = false"
            >{{ alert_error_message }}</b-alert
        >

        <b-container fluid>
            <h3 class="mt-3 mb-3">Transactions View</h3>

            <div
                class="search_bar mb-3"
                v-if="
                    checkPermission(
                        $store.state.user_obj,
                        'Warehouse Management',
                        'Inventory - Transactions',
                        'Upload Transactions',
                        true
                    )
                "
            >
                <b-row>
                    <b-col cols="4" class="pr-1">
                        <b-form-file
                            v-model="upload_file"
                            placeholder="Choose a file..."
                            size="sm"
                        ></b-form-file>
                    </b-col>

                    <b-col class="text-left p-0">
                        <b-button
                            class="btn-action"
                            size="sm"
                            variant="info"
                            @click="onUploadFile"
                            >Upload</b-button
                        >
                    </b-col>
                </b-row>
            </div>

            <div class="search_bar mb-3">
                <b-row>
                    <b-col cols="2" class="pr-1">
                        <b-form-select
                            size="sm"
                            v-model="search_criteria.channel_selected"
                            :options="channel_options"
                        />
                    </b-col>

                    <b-col cols="2" class="pl-0 pr-1">
                        <b-form-select
                            size="sm"
                            v-model="search_criteria.action_selected"
                            :options="action_options"
                        />
                    </b-col>

                    <b-col cols="2" class="pl-0 pr-1">
                        <b-form-input
                            id="input-small"
                            size="sm"
                            type="date"
                            v-model="search_criteria.start_at"
                        ></b-form-input>
                    </b-col>
                    <b-col cols="2" class="pl-0 pr-1">
                        <b-form-input
                            id="input-small"
                            size="sm"
                            type="date"
                            v-model="search_criteria.end_at"
                        ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="mt-1">
                    <b-col cols="3" class="pr-1">
                        <b-form-input
                            id="input-small"
                            size="sm"
                            type="text"
                            placeholder="Product SKU / Channel SKU / Other SKU"
                            v-model="search_criteria.keyword"
                        ></b-form-input>
                    </b-col>

                    <b-col class="text-left p-0">
                        <b-button
                            class="btn-action"
                            size="sm"
                            variant="info"
                            @click="onSearch"
                        >
                            <font-awesome-icon
                                class="mr-1"
                                icon="search"
                            />Search
                        </b-button>

                        <b-button
                            v-if="
                                checkPermission(
                                    $store.state.user_obj,
                                    'Warehouse Management',
                                    'Inventory - Transactions',
                                    'Export CSV',
                                    true
                                )
                            "
                            class="btn-action"
                            size="sm"
                            variant="info"
                            @click="onExport"
                            >Export</b-button
                        >
                    </b-col>
                </b-row>
            </div>

            <b-pagination
                size="sm"
                :total-rows="total_rows"
                v-model="currentPage"
                :per-page="TABLE_LIMIT"
                @change="onPageChange"
                :limit="PAGING_LIMIT"
            ></b-pagination>

            <b-table
                responsive
                small
                outlined
                striped
                hover
                sticky-header="500px"
                :items="items"
                :fields="fields"
            >
                <template v-slot:cell(action_at)="data">
                    <div>
                        {{ displayDate(data.item.action_at) }}
                    </div>
                </template>

                <template v-slot:cell(stock_in_date)="data">
                    <div>
                        {{ displayDate(data.item.stock_in_date) }}
                    </div>
                </template>

                <template v-slot:cell(actions)="data">
                    <b-button
                        v-if="
                        ($store.state.user_obj.account_type == 'client_admin') || 
                            checkPermission(
                                $store.state.user_obj,
                                'Warehouse Management',
                                'Inventory - Transactions',
                                'Edit',
                                true
                            )
                        "
                        class="btn-action"
                        size="sm"
                        variant="info"
                        @click="openEditRemarkModal(data.item)"
                        >Edit</b-button
                    >
                </template>
            </b-table>

            <b-pagination
                size="sm"
                :total-rows="total_rows"
                v-model="currentPage"
                :per-page="TABLE_LIMIT"
                @change="onPageChange"
                :limit="PAGING_LIMIT"
            ></b-pagination>

            <b-modal
                ref="modal_edit_remark_ref"
                title="Edit Remark"
                @hidden="resetEditRemarkRef"
                @ok="handleEditRemarkOk"
            >
                <form ref="form">
                    <b-row class="mb-2">
                        <b-col class="col-6">
                            <strong>Remark</strong>
                        </b-col>
                        <b-col>
                            <b-form-group>
                                <b-form-textarea
                                    size="sm"
                                    type="text"
                                    placeholder
                                    v-model="remark_obj.remark"
                                ></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </form>
            </b-modal>
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";

const fields = [
    // {
    //   key: "action_at",
    //   label: "Action at"
    // },
    {
        key: "channel",
        label: "Channel"
    },
    {
        key: "product_sku",
        label: "Product SKU"
    },
    {
        key: "channel_sku",
        label: "Channel SKU"
    },
    {
        key: "vendor_lot_number",
        label: "Lot #"
    },
    {
        key: "product_description",
        label: "Item Description"
    },
    {
        key: "quantity",
        label: "Qty",
        class: "center_align"
    },
    {
        key: "action",
        label: "Action",
        class: "center_align txt_camelcase"
    },

    {
        key: "stock_in_date",
        label: "SID",
        class: "center_align"
    },
    {
        key: "from_location",
        label: "From Location",
        class: "center_align"
    },
    {
        key: "from_inventory_type",
        label: "From Inventory Type",
        class: "center_align txt_camelcase"
    },
    {
        key: "to_location",
        label: "To Location",
        class: "center_align"
    },
    {
        key: "to_inventory_type",
        label: "To Inventory Type",
        class: "center_align txt_camelcase"
    },
    {
        key: "remark",
        label: "Remark"
    },
    {
        key: "action_by_name",
        label: "Action by"
    },
    {
        key: "action_at",
        label: "Action at"
    },
    {
        key: "remark",
        label: "Remark",
    },
    {
        key: "actions",
        label: "Actions"
    }
];

const fields_vendor2 = [
    // {
    //   key: "action_at",
    //   label: "Action at"
    // },
    {
        key: "channel",
        label: "Channel"
    },
    {
        key: "product_sku",
        label: "Product SKU"
    },
    {
        key: "channel_sku",
        label: "Channel SKU"
    },
    {
        key: "vendor_lot_number",
        label: "Lot #"
    },
    {
        key: "product_description",
        label: "Item Description"
    },
    {
        key: "quantity",
        label: "Qty",
        class: "center_align"
    },
    {
        key: "action",
        label: "Action",
        class: "center_align txt_camelcase"
    },

    {
        key: "stock_in_date",
        label: "SID",
        class: "center_align"
    },
    {
        key: "from_inventory_type",
        label: "From Inventory Type",
        class: "center_align txt_camelcase"
    },
    {
        key: "to_inventory_type",
        label: "To Inventory Type",
        class: "center_align txt_camelcase"
    },
    {
        key: "remark",
        label: "Remark"
    },
    // {
    //   key: "action_by_name",
    //   label: "Action by"
    // },
    {
        key: "action_at",
        label: "Action at"
    }
];

import global_function from "../mixins/global_function";

export default {
    name: "WMS_Transactions",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
    mixins: [apiService, global_function],
    components: {
        barcode: VueBarcode
    },
    data() {
        return {
            courier_options: [],
            export_date: {
                start_at: moment()
                    .subtract(7, "d")
                    .format("YYYY-MM-DD"),
                end_at: moment().format("YYYY-MM-DD")
            },
            upload_file: [],
            loader_full: false,
            loader: false,
            items: [],
            fields: null,
            currentPage: 1,
            table_offset: 0,
            total_rows: 0,
            updating_item: false,
            export_criteria: {
                courier_selected: null,
                status_selected: null
            },
            search_criteria: {
                keyword: "",
                channel_selected: null,
                action_selected: null,
                start_at: moment()
                    .subtract(30, "days")
                    .format("YYYY-MM-DD"),
                end_at: moment().format("YYYY-MM-DD")
            },
            showAlert_success: false,
            alert_success_message: "",

            showAlert_error: false,
            alert_error_message: "",

            channel_options: [
                {
                    text: "All Channel",
                    value: null
                }
            ],

            selected_wms_transaction_id: null,
            remark_obj: {
                remark: ''
            },

            action_options: [
                {
                    text: "All Action",
                    value: null
                },
                {
                    text: "stock out",
                    value: "stock out"
                },
                {
                    text: "stock in",
                    value: "stock in"
                },
                {
                    text: "transfer",
                    value: "transfer"
                },
                {
                    text: "adjust",
                    value: "adjust"
                }
            ],

            status_options: [
                {
                    value: null,
                    text: "All Status"
                },
                {
                    value: "Fulfilled",
                    text: "Fulfilled"
                },
                {
                    value: "Failed",
                    text: "Failed"
                }
            ]
        };
    },
    async created() {
        await this.getWMS_Transactions();

        let channels_response = await this.getChannels(
            this.$store.state.user_obj
        );
        for (let i in channels_response.channels) {
            this.channel_options.push({
                value: channels_response.channels[i].name,
                text: channels_response.channels[i].name
            });
        }

        if (
            this.$store.state.user_obj.name == "aml_comvita" ||
            this.$store.state.user_obj.name == "aml_vendor_master" ||
            this.$store.state.user_obj.account_type == "vendor_2"
        ) {
            this.fields = fields_vendor2;
        } else {
            this.fields = fields;
        }

        this.initialized = true;
    },
    mounted() {
        this.loader = this.$loading.show({
            isFullPage: true,
            canCancel: false
        });
    },
    methods: {
        exportCSV() {
            let export_url =
                process.env.VUE_APP_API_HOST + "/export_transactions.php?";
            export_url += "&client_id=" + this.$store.state.user_obj.client_id;
            export_url = encodeURI(export_url);
            window.open(export_url, "_blank");
        },

        onExport() {
            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false
            });

            this.$http({
                url: this.NODEJS_API_URL + "/gen_excel",
                method: "POST",
                data: {
                    export_type: "wms_transaction",
                    limit: 999999,
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                },
                responseType: "blob" // important
            }).then(response => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "wms_transaction.xlsx");
                document.body.appendChild(link);
                link.click();

                this.loader.hide();
            });
        },

        displayDate(d) {
            if (d && d != "NA" && d != "") {
                if (
                    this.$store.state.user_obj.account_type ==
                    "young_living_logistic"
                ) {
                    return moment(d).format("YYYY-MM-DD");
                } else {
                    return moment(d).format("YYYY-MM-DD");
                }
            } else {
                return "/";
            }
        },

        async getWMS_Transactions() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false
            });
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "wms_transaction_get.php",
                data: {
                    offset: this.table_offset,
                    limit: this.TABLE_LIMIT,
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });
            this.items = response.data.transactions;
            this.total_rows = parseInt(response.data.total_rows);
            this.loader.hide();
            this.loader_full.hide();
        },

        onSearch() {
            this.getWMS_Transactions();
        },

        onPageChange(page_to_change) {
            this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
            this.getWMS_Transactions();
        },

        async onUploadFile() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false
            });

            let formData = new FormData();
            formData.append("excel_file", this.upload_file);
            formData.append("user_id", this.$store.state.user_obj.user_id);
            formData.append("client_id", this.$store.state.user_obj.client_id);

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "wms_transaction_import.php",
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                data: formData
            });

            if (response) {
                this.loader_full.hide();
                // this.$eventHub.$emit("show_modal_message", {
                //     message_content: 'Upload Success'
                // });

                if (response.data.status == "success") {
                    this.$eventHub.$emit("show_modal_message", {
                        message_content: "Upload Success"
                    });
                } else {
                    this.$eventHub.$emit("show_modal_message", {
                        message_content: response.data.error_msg
                    });
                }

                this.getWMS_Transactions();
            }
        },

        openEditRemarkModal: function(item) {
            this.selected_wms_transaction_id = item.id;
            this.remark_obj = {
                ...this.remark_obj,
                remark: item.remark
            }
            this.$refs.modal_edit_remark_ref.show();
        },

        resetEditRemarkRef() {
            this.remark_obj = {
                ...this.remark_obj,
                remark: ""
            };
        },

        async handleEditRemarkOk(event) {
            event.preventDefault();

            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false
            });

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "wms_transaction_remark_edit.php",
                data: {
                    edit_remark_obj: this.remark_obj,
                    wms_transaction_id: this.selected_wms_transaction_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            if (response.data.status == "success") {
                this.alert_success_message = `Edit Success`;
                this.showAlert_success = true;
                setTimeout(() => {
                    this.showAlert_success = false;
                    this.alert_success_message = "";
                }, 3000);
            } else {
                this.alert_error_message = response.data.message;
                this.showAlert_error = true;
                setTimeout(() => {
                    this.showAlert_error = false;
                    this.alert_error_message = "";
                }, 3000);
            }

            this.$refs.modal_edit_remark_ref.hide();

            this.loader_full.hide();

            this.getWMS_Transactions();
        }
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/WMS_Transactions.vue